export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          联系我们
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
          有资源需求、问题反馈或商务合作？欢迎联系我们
        </p>

        <div className="mt-8 md:mt-10 bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900">商务合作</span>
              <span className="text-xs text-foreground-500">bd@97ys.com</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-bug-line text-accent-500 text-xl"></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900">问题反馈</span>
              <span className="text-xs text-foreground-500">feedback@97ys.com</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-send-plane-line text-secondary-500 text-xl"></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900">资源投稿</span>
              <span className="text-xs text-foreground-500">submit@97ys.com</span>
            </div>
          </div>
          <p className="mt-6 text-xs text-foreground-400">
            工作时间：周一至周日 9:00 - 22:00 · 通常2小时内回复
          </p>
        </div>
      </div>
    </section>
  );
}